import Users from "./users-list";
import UserDetail from "./user-detail";
import NewUser from "./user-new";

export { UserDetail, NewUser };
export default Users;